__turbopack_context__.v({
  "holidayIcon": "IconCategoryMap-module-scss-module__fH3lKa__holidayIcon",
  "iconFill": "IconCategoryMap-module-scss-module__fH3lKa__iconFill",
  "iconSize": "IconCategoryMap-module-scss-module__fH3lKa__iconSize",
  "nyeIcon": "IconCategoryMap-module-scss-module__fH3lKa__nyeIcon",
  "strokeWidth": "IconCategoryMap-module-scss-module__fH3lKa__strokeWidth",
});
